<template>
<div>
     <v-container>
      <v-row>
        <v-col>
          <div class="home-title mt-4 card-title">
           Construction
            <v-btn text to="/">Go Back</v-btn>
          </div>
        </v-col>
      </v-row>
    </v-container>
   
    <v-container>
      <v-row wrap>
        <v-col lg="12" sm="12">
          <v-card>
            <v-img src="../assets/images/Photo_10___Construction_2017_36_1.jpg"></v-img>
 <image-viewer source="Photo_10___Construction_2017_36_1.jpg"></image-viewer>
            <v-card-text class="body-1">Members of the Welland Ship Canal Electrical Workers Organization gathered together for this photograph in 1920. They were among thousands of skilled workers and general labourers who worked on the construction of the Fourth Welland Canal. More than 130 workers died during the construction phase.</v-card-text>
          </v-card>
        </v-col>

          <v-col lg="12" sm="12">
          <v-card>
            <v-img src="../assets/images/Photo_3___Construction_983_2_1.jpg"></v-img>
 <image-viewer source="Photo_3___Construction_983_2_1.jpg"></image-viewer>
            <v-card-text class="body-1">Workers posing with one of the locomotives used during the construction of the Fourth Welland Canal. Temporary construction railways made the excavation and construction process much more efficient than the horses and mules which had provided power during the construction of the three earlier canals, c. 1927.</v-card-text>
          </v-card>
        </v-col>
        <v-col lg="4" sm="12">
          <v-card>
            <v-img src="../assets/images/Photo_1__Construction_986_82_244.jpg"></v-img>
 <image-viewer source="Photo_1__Construction_986_82_244.jpg"></image-viewer>
            <v-card-text class="body-1">Excavation for the construction of the Third Welland Canal on the east side of Port Colborne. c.1870</v-card-text>
          </v-card>
        </v-col>

        <v-col lg="4" sm="12">
          <v-card>
            <v-img src="../assets/images/Photo_2__Construction_986_82_245.jpg"></v-img>
 <image-viewer source="Photo_2__Construction_986_82_245.jpg"></image-viewer>
            <v-card-text class="body-1">Excavation for the construction of the Third Welland Canal on the west side of Port Colborne, c.1870</v-card-text>
          </v-card>
        </v-col>

      

        <v-col lg="4" sm="12">
          <v-card>
            <v-img src="../assets/images/Photo_4___Construction_2009_20_212_Canal_Construction_PC_West_St_in_background.jpg"></v-img>
 <image-viewer source="Photo_4___Construction_2009_20_212_Canal_Construction_PC_West_St_in_background.jpg"></image-viewer>
            <v-card-text class="body-1">Excavation of the Fourth Canal at Port Colborne with West Street in the background, c. 1927.</v-card-text>
          </v-card>
        </v-col>

        <v-col lg="4" sm="12">
          <v-card>
            <v-img src="../assets/images/Photo_5__Construction_985_98_2.jpg"></v-img>
 <image-viewer source="Photo_5__Construction_985_98_2.jpg"></image-viewer>
            <v-card-text class="body-1">The construction of the new bridge and water control structures for the weir at Humberstone, c.1929.</v-card-text>
          </v-card>
        </v-col>

        <v-col lg="4" sm="12">
          <v-card>
            <v-img src="../assets/images/Photo_6___Construction_992_36_4.jpg"></v-img>
 <image-viewer source="Photo_6___Construction_992_36_4.jpg"></image-viewer>
            <v-card-text class="body-1">Lock 8 construction nearing completion, 20th May 1928</v-card-text>
          </v-card>
        </v-col>

        <v-col lg="4" sm="12">
          <v-card>
            <v-img src="../assets/images/Photo_7__Construction_Welland_Canal_993_13_17.jpg"></v-img>
 <image-viewer source="Photo_7__Construction_Welland_Canal_993_13_17.jpg"></image-viewer>
            <v-card-text class="body-1">Deepening the guard lock on the third canal, with one half of the Hopkins Swing Bridge visible at the end of the lock, c.1900.</v-card-text>
          </v-card>
        </v-col>

        <v-col lg="4" sm="12">
          <v-card>
            <v-img src="../assets/images/Photo_8__Construction_985_109_49.jpg"></v-img>
 <image-viewer source="Photo_8__Construction_985_109_49.jpg"></image-viewer>
            <v-card-text class="body-1">1930s photograph of a cave-in of the side wall of the harbour along West Street</v-card-text>
          </v-card>
        </v-col>

        <v-col lg="4" sm="12">
          <v-card>
            <v-img src="../assets/images/Photo_9___Construction_986_63_3.jpg"></v-img>
 <image-viewer source="Photo_9___Construction_986_63_3.jpg"></image-viewer>
            <v-card-text class="body-1">Bill Fraser standing on one of the large steam shovels used in the harbour improvements and during the construction of the Fourth Welland Canal.</v-card-text>
          </v-card>
        </v-col>

    

      </v-row>
    </v-container>
</div>
</template>


<script>

export default {
  name: 'Contruction',
  components: {
  }
}
</script>

<style>
</style>